import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@components/Modal/Modal";
import { BankSelectContent, BankSelectContentProps } from "./BankSelectContent";

type Props = BankSelectContentProps;

export const BankSelect = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      title={t("bankSelect.pageTitle")}
      width={768}
    >
      <BankSelectContent {...props} />
    </Modal>
  );
};
